import React from 'react';

import PDPGallery from './pdp-gallery';
import Offers from './above-the-fold-offers';
import TitleSection from './title-section';
import ProductDetailsContainer from './pdp-detail-container';
import StickyWrapper from './sticky-wrapper';
import ShadowHeader from '../shadow-header';
import HeroSection from './hero-section';
import HeroSectionV2 from './product-hero-container';
import withPageComponents from '../../../page/components/with-page-components';
import { showDualCtaForKit } from '../../../product/get-product-props/get-enrollment-kit-props';

const SHADOW_PDP_TOP_OFFSET = 150;
const NON_SHADOW_PDP_TOP_OFFSET = 16;

const pdpDetails = ({ productInitial, pdpShadowCTO, templateKey }) => {
    const { shadowCTOEnabled } = pdpShadowCTO || {};
    const priceAboveTheFold = showDualCtaForKit(productInitial);
    return (
        <div style={{ position: 'relative' }}>
            <ShadowHeader v2={priceAboveTheFold} templateKey={templateKey} />
            <ProductDetailsContainer>
                <div className={`image-section${priceAboveTheFold ? ' v2' : ''}`}>
                    <StickyWrapper
                        className="pdp-sticky-container"
                        position="static"
                        topOffset={shadowCTOEnabled ? SHADOW_PDP_TOP_OFFSET : NON_SHADOW_PDP_TOP_OFFSET}
                    >
                        {!shadowCTOEnabled && (
                            <TitleSection
                                showFor={!priceAboveTheFold ? ['mobile'] : undefined}
                                v2={priceAboveTheFold}
                            />
                        )}
                        <PDPGallery />
                        <Offers showFor={['desktop', 'tablet']} />
                    </StickyWrapper>
                </div>
                {!priceAboveTheFold ? <HeroSection /> : <HeroSectionV2 templateKey={templateKey} />}
            </ProductDetailsContainer>
            <Offers showFor={['mobile']} className="pdp-mobile-offers" />
        </div>
    );
};
export default withPageComponents(pdpDetails, { components: ['pdpShadowCTO', 'productInitial'] });
